import { render, staticRenderFns } from "./LogoAnimation.vue?vue&type=template&id=4cde4677&"
import script from "./LogoAnimation.vue?vue&type=script&lang=js&"
export * from "./LogoAnimation.vue?vue&type=script&lang=js&"
import style0 from "./LogoAnimation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports